import { Type } from 'class-transformer';
import { BudgetedGLAccountSelectorResultDto } from '../../../cirabooks/shared-cirabooks-module/_models/accounts-payable/ap-bill/budgeted-gl-account-selector-result-dto';
import { DimensionSelectorResultDto } from '../../../cirabooks/shared-cirabooks-module/_models/common/dimensions/dimension-selector-result-dto';
import { WFEBankAccountResultDto } from '../../../shared-workflow-module/_models/wfe-bank-account-result-dto';
import { WFEWorkflowRawDto } from '../../../shared-workflow-module/_models/wfe-workflow-raw-dto';
import { KeyValueResultDto } from '../../../_models/key-value-result-dto';
import { WFECommunityResultDto } from '../../../shared-workflow-module/_models/wfe-community-result-dto';

export class WFEAccountantStepEditorResultDto {
    allowUpdateInReview: boolean;
    allowCreateBillAndHold: boolean;
    allowReverse: boolean;
    allowDelete: boolean;
    allowReclassifyBill: boolean;
    allowUpdateBill: boolean;

    linkedWorkOrderIds: Array<number>;

    @Type(() => WFEWorkflowRawDto)
    workflow: WFEWorkflowRawDto;

    payee: string;
    vendorAccountNumber: string;
    managementCompanyId: number;
    boardApprovalEnabled: boolean;

    @Type(() => Date)
    closedBookPeriod: Date;

    @Type(() => KeyValueResultDto)
    wfStatusBreadcrumb: Array<KeyValueResultDto>;

    bankBalance: number;
    matchEntityRequiredDimensions: boolean;
    allowApprove: boolean;
    allowDeny: boolean;
    hasVendorNotes: boolean;
    vendorInstruction: string;
    managementCompanyVendorId: number;
    hasVendorWFCheckList: boolean;
    hasBoardNotes: boolean;

    @Type(() => WFECommunityResultDto)
    targetCommunityList: Array<WFECommunityResultDto>;

    @Type(() => WFEBankAccountResultDto)
    bankAccounts: Array<WFEBankAccountResultDto>;

    @Type(() => BudgetedGLAccountSelectorResultDto)
    glAccounts: Array<BudgetedGLAccountSelectorResultDto>;

    @Type(() => DimensionSelectorResultDto)
    dimensions: Array<DimensionSelectorResultDto>;

    entityUsesSubCategory: boolean;
    isActiveCommunityVendor: boolean;

    communityTerminated: boolean;
}
